import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import TitleWithBack from '../../components/common/TitleWithBack';
import { ProgressBar } from 'react-bootstrap';
import { downloadBulkUploadTemplate } from '../../utils/bulkUploadTemplates';

function ExamCentresCreate() {
  const [activeTab, setActiveTab] = useState('single');
  const [centreName, setCentreName] = useState('');
  const [location, setLocation] = useState('');
  const [centreNumber, setCentreNumber] = useState('');
  const [uploadFile, setUploadFile] = useState(null);
  const [tooltip, setTooltip] = useState('');
  const [uploadProgress, setUploadProgress] = useState(0); 
  const [isUploading, setIsUploading] = useState(false);
  const navigate = useNavigate();

  const handleSingleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      centreName,
      location,
      centreNumber  // Sending as string to support letters
    };
    console.log('Payload:', payload);
    try {
      await axios.post('/api/exam-centres', payload);
      setTooltip('Exam centre created successfully!');
      setTimeout(() => navigate('/admin/exam-centres/view'), 2000);
    } catch (err) {
      setTooltip('Error creating exam centre.');
    }
  };

  const handleBulkSubmit = async (e) => {
    e.preventDefault();
    if (!uploadFile) return;
    const formData = new FormData();
    formData.append('file', uploadFile);
    setIsUploading(true); 
    setUploadProgress(0);
    try {
      await axios.post('/api/bulk-upload/exam-center', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percent);
        }
      });
      setTooltip('Exam centres uploaded successfully!');
      setUploadProgress(100);
      setTimeout(() => navigate('/admin/exam-centres/view'), 2000);
    } catch (err) {
      let backendMessage = ' Unknown error occurred while uploading.';
        if (err.response && err.response.data) {
           if (typeof err.response.data === 'string') {
             backendMessage = err.response.data;
            }
            else if (typeof err.response.data.message === 'string') {
              backendMessage = err.response.data.message;
            }
        }
    setTooltip(`Error: ${backendMessage}`);
    }
    finally {
      setIsUploading(false); 
    }
  };

  return (
    <div className="container mt-2">
      <TitleWithBack title="Create Exam Centre" />
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button 
            type="button"
            className={`nav-link ${activeTab === 'single' ? 'active' : ''}`}
            onClick={() => { setActiveTab('single'); setUploadFile(null); }}
          >
            Single Create
          </button>
        </li>
        <li className="nav-item">
          <button 
            type="button"
            className={`nav-link ${activeTab === 'bulk' ? 'active' : ''}`}
            onClick={() => setActiveTab('bulk')}
          >
            Bulk Upload
          </button>
        </li>
      </ul>
      {activeTab === 'single' ? (
        <div className="card shadow-sm">
          <div className="card-body">
            <form onSubmit={handleSingleSubmit}>
              <div className="mb-3">
                <label className="form-label">Centre Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={centreName}
                  onChange={(e) => setCentreName(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Location</label>
                <input
                  type="text"
                  className="form-control"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Centre Number</label>
                <input
                  type="text"
                  className="form-control" 
                  value={centreNumber}
                  onChange={(e) => setCentreNumber(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary">Create Exam Centre</button>
            </form>
          </div>
        </div>
      ) : (
        <div className="card shadow-sm">
          <div className="card-body">
            <form onSubmit={handleBulkSubmit}>
              <div className="mb-3">
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => downloadBulkUploadTemplate('examCentre')}
                >
                  Download Template
                </button>
              </div>
              <div className="mb-3">
                <label className="form-label">Select Excel File</label>
                <input
                  type="file"
                  className="form-control"
                  accept=".xls,.xlsx"
                  onChange={(e) => setUploadFile(e.target.files[0])}
                />
              </div>
              {uploadFile && (
                <p className="fst-italic">File selected: {uploadFile.name}</p>
              )}
              <button type="submit" className="btn btn-primary">Upload Exam Centres</button>
              {isUploading && (
              <div className="my-3">
              <ProgressBar 
              now={uploadProgress}
              label={`${uploadProgress}%`}
              animated
              variant={uploadProgress < 100 ? 'info' : 'success'}
             />
            </div>
            )}
            </form>
          </div>
        </div>
      )}
      {tooltip && (
        <div className={`mt-3 alert ${tooltip.includes('Error') ? 'alert-danger' : 'alert-success'}`}>
          {tooltip}
        </div>
      )}
    </div>
  );
}

export default ExamCentresCreate;
